<template>
  <div>
    <el-form label-position="left" label-width="150px">
      <el-form-item label="合同名字">
        <el-input v-model="detail.contractName" readonly></el-input>
      </el-form-item>

      <el-form-item label="合同金额">
        <el-input v-model="detail.contractAmount" readonly></el-input>
      </el-form-item>

      <el-form-item v-for="(item, index) in detail.signCompany" :label="domainText[index] + '方'">
        <div v-if="item.name"><span>合同名字</span><el-input v-model="item.name" readonly/></div>
        <div v-if="item.contact"><span>联系方式</span><el-input v-model="item.contact" readonly/></div>
        <div v-if="item.remark"><span>备注</span><el-input v-model="item.remark" readonly/></div>
      </el-form-item>

      <el-form-item label="合同签署时间">
        <el-date-picker
          readonly
          v-model="detail.contractUpTime"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="合同文件">
        <el-link type="primary" @click="download()">下载文件</el-link>
        <el-link style="margin-left: 8px" v-if="isPdf(detail.filePath)" type="primary" @click="viewPdf(detail.filePath)">预览</el-link>
      </el-form-item>
      
      <el-form-item label="备注">
        <el-input v-model="detail.remarks" readonly></el-input>
      </el-form-item>

      <el-form-item></el-form-item>
    </el-form>

    <el-dialog :visible.sync="showPdf" :append-to-body="true" top="0" custom-class="pdf-viewer">
      <div style="width: 100%; height: 100%">
        <iframe
          id="myIframe"
          :src="pdfurl"
          width="100%"
          height="900px"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {requestGetContractInfo} from "@/api"
import {minioServer, IsPdf} from "@/util";
export default {
  name: "ContractDialog",
  props: {
    "contractId": "",
    "role": 0
  },
  data() {
    return {
      domainText: ['甲','乙','丙','丁','戊','己','庚','辛','壬','癸'],
      showPdf: false,
      pdfurl: "",
      detail: {},
    };
  },
  created() {
    this.getContractInfo()
  },
  methods: {
    async getContractInfo() {
      const res = await requestGetContractInfo({contractId: this.contractId})
      if (res.code === 200) {
        this.detail = res.object
        this.detail.signCompany = JSON.parse(res.object.signCompany)
      }
    },
    download() {
      window.open(minioServer + this.detail.filePath)
    },
    isPdf(file) {
      return IsPdf(file)
    },
    viewPdf(path) {
      this.showPdf = true
      this.pdfurl = "/pdfjs/web/viewer.html?file=" + minioServer + path
    }
  }
};
</script>

<style></style>